import { getUTCDateString, formatStartDate, formatEndDate } from 'helpers/dateHelper';
import { DAY_IN_MS } from 'helpers/constants';
import moment from 'moment';

// Default date range selection from MAX_DAYS_RANGE ago (the beginning of that day) to the end of the present day.
export const getInitialStartDate = (defaultRange) => {
    const fromDate = new Date();
    fromDate.setTime(fromDate.getTime() - (defaultRange - 1) * DAY_IN_MS);
    const formated = formatStartDate(fromDate);
    return getUTCDateString(formated);
};

export const getInitialEndDate = () => {
    const toDate = formatEndDate(new Date());
    toDate.setTime(toDate.getTime());
    return getUTCDateString(toDate);
};

// Default date range selection from defaultRange days ago to current time
export const getInitialFleetDetailedReportStartDate = (defaultRange) => {
    const startDate = moment().subtract(defaultRange - 1, 'days').toDate();
    return getUTCDateString(startDate);
};

export const getInitialFleetDetailedReportEndDate = () => {
    const endDate = formatEndDate(new Date());
    return getUTCDateString(endDate);
};

export const getInitialStartDateExcludeToday = (defaultRange) => {
    const startDate = moment().subtract(defaultRange, 'days').startOf('day').toDate();
    return getUTCDateString(startDate);
};

export const getYesterdayEndDate = () => {
    const yesterday = moment().subtract(1, 'day').endOf('day').toDate();
    return getUTCDateString(yesterday);
};
